// The two shapes a dialog can take, shared by Dialog and AlertDialog so the
// phone behaviour cannot drift between them (HANDOFF "Phone layout rules").
//
// dialogSheetBase (the default): under `sm` the dialog is a bottom sheet,
// full width, anchored to the bottom of the screen (and to the top of the
// keyboard while typing, see useKeyboardBox), with its own scroll; from `sm`
// up it is the centred box. Callers add a max width or a height on top.
//
// dialogCenteredBase: the centred box on every width, for dialogs that lay
// themselves out (full-screen concierge, the tall map and preview boxes, the
// command palette) and pass phoneSheet={false}.

const shared =
  "fixed z-overlay grid gap-4 border bg-background p-6 shadow-lg transition-none duration-200 overflow-y-auto overscroll-contain data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0";

const centered =
  "left-1/2 top-1/2 w-[calc(100%-2rem)] max-w-lg max-h-[calc(100dvh-2rem)] -translate-x-1/2 -translate-y-1/2 rounded-lg";

const centeredMotion =
  "data-[state=open]:zoom-in-95 data-[state=closed]:zoom-out-95 data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]";

export const dialogCenteredBase = `${shared} ${centered} ${centeredMotion}`;

export const dialogSheetBase = [
  shared,
  // Phone: the sheet. scroll-pt/pb keep a focused field clear of the sticky
  // header and footer (index.css, [data-phone-sheet]).
  "inset-x-0 bottom-0 top-auto mx-auto w-full max-w-lg max-h-[calc(100dvh-3rem)] rounded-t-2xl rounded-b-none border-b-0 scroll-pt-20 scroll-pb-28 pb-[max(1.5rem,env(safe-area-inset-bottom))]",
  "max-sm:data-[state=open]:slide-in-from-bottom max-sm:data-[state=closed]:slide-out-to-bottom",
  // Desktop: the centred box.
  "sm:inset-x-auto sm:left-1/2 sm:top-1/2 sm:bottom-auto sm:mx-0 sm:w-[calc(100%-2rem)] sm:max-h-[calc(100dvh-2rem)] sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-lg sm:border-b sm:pb-6 sm:scroll-p-0",
  centeredMotion.split(" ").map((c) => `sm:${c}`).join(" "),
].join(" ");

export const dialogCloseBase =
  "absolute right-2 top-2 z-20 rounded-sm p-2 opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none";
